import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Option} from './option';

@Component({
    selector: 'app-option-row',
    templateUrl: './option-row.component.html',
    styleUrls: ['./option-row.component.scss']
})
export class OptionRowComponent {
    @Input()
    option: Option;

    @Output()
    onApply: EventEmitter<Option> = new EventEmitter();

    async apply(option: Option): Promise<void> {
        this.onApply.emit(option);
    }
}
